import {
    SidebarMenu,
    SidebarMenuButton,
    SidebarMenuItem,
} from "@/components/ui/sidebar";
import { cn } from "@/lib/utils";
import { ChevronDown,LucideIcon } from "lucide-react";
import { useState } from "react";
import { Link } from "react-router-dom";

interface NavItem {
    title: string;
    url: string;
    icon: LucideIcon;
    isActive?: boolean;
    items?: {
        title: string;
        url: string;
    }[];
}

interface NavMainProps {
    items: NavItem[];
}

export const NavMain = ({ items }: NavMainProps) => {
    const [expandedItems, setExpandedItems] = useState<Record<string, boolean>>(
        {},
    );

    const handleToggleSubmenu = (url: string) => {
        setExpandedItems((prev) => ({
            ...prev,
            [url]: !prev[url],
        }));
    };

    return (
        <SidebarMenu>
            {items.map((item) => (
                <SidebarMenuItem key={item.url}>
                    {item.items ? (
                        <div className="flex flex-col">
                            <SidebarMenuButton
                                size="default"
                                isActive={item.isActive}
                                onClick={() => handleToggleSubmenu(item.url)}
                                className="w-full"
                            >
                                <div className="flex w-full items-center justify-between">
                                    <div className="flex items-center gap-2">
                                        <item.icon className="size-4" />
                                        <span>{item.title}</span>
                                    </div>
                                    <ChevronDown
                                        className={cn(
                                            "size-4 transition-transform duration-200",
                                            expandedItems[item.url] && "rotate-180",
                                        )}
                                    />
                                </div>
                            </SidebarMenuButton>
                            {expandedItems[item.url] && (
                                <div className="ml-4 mt-1 flex flex-col gap-1">
                                    {item.items.map((subItem) => (
                                        <SidebarMenuButton
                                            key={subItem.url}
                                            size="sm"
                                            variant="default"
                                            asChild
                                        >
                                            <Link to={subItem.url}>
                                                <span>{subItem.title}</span>
                                            </Link>
                                        </SidebarMenuButton>
                                    ))}
                                </div>
                            )}
                        </div>
                    ) : (
                        <SidebarMenuButton
                            size="default"
                            isActive={Boolean(item.isActive)}
                            asChild
                        >
                            <Link to={item.url}>
                                <item.icon className="size-4" />
                                <span>{item.title}</span>
                            </Link>
                        </SidebarMenuButton>
                    )}
                </SidebarMenuItem>
            ))}
        </SidebarMenu>
    );
};
